import React from 'react';
import { Outlet } from 'react-router-dom';

const GetStartedContent = () => {
  return <Outlet />;
};

export default GetStartedContent;
